import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    labelClassName,
    videoPlayerClassName,
    imageClassName,
    captionClassName,
} from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const VideoGrid: StyleRule = ({ theme }) => ({
    gap: pxToRem(60),

    [theme.screen.laptop]: {
        gridGap: `${pxToRem(76)} 0`,
    },
});

interface ImageDimension {
    width: number;
    height: number;
}

export const VideoPlaceholder: (imageDimensions: ImageDimension) => StyleRule =
    (imageDimensions) => () => {
        return {
            position: 'relative',
            width: pxToRem(imageDimensions.width),
            height: pxToRem(imageDimensions.height),
        };
    };

export const VideoTile: StyleRule<{ showFilled: boolean }> = ({
    theme,
    showFilled,
}) => ({
    position: `relative`,
    gridGap: pxToRem(8),

    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
    },

    [`& .${captionClassName}`]: {
        lineHeight: 1.5,
        padding: pxArrayToRem([16, 18, 0, 18]),
        fontSize: pxToRem(12),
    },

    [`& .${videoPlayerClassName}`]: {
        overflow: 'hidden',
        width: '100%',

        [`& .${imageClassName}`]: {
            [`& svg`]: {
                margin: pxArrayToRem([-1, 0, 0, -3]),
            },
        },
    },

    [theme.screen.laptop]: {
        gridGap: pxToRem(30),
        padding: pxToRem(14),
        paddingBottom: 0,

        [`& .${captionClassName}`]: {
            padding: 'unset',
            fontSize: 'unset',
        },

        [`& .${videoPlayerClassName} .${svgIconClassName} svg`]: {
            marginLeft: pxToRem(-6),
        },

        ...(!showFilled && {
            [`& .${videoPlayerClassName} .${imageClassName}`]: {
                [`& svg`]: {
                    margin: 0,
                },
            },
        }),
    },
});
